// import { labelSearch } from '@/api/task/taskModel'
const state = {
  info: {
    til: '觅特友',
    title: '觅特友企业后台',
    company: '觅特友有限公司',
    theme: '#1677FF',
    logo: 'http://meetyou-api.oss-cn-hangzhou.aliyuncs.com/advertising/2022-10/13/logo-top166565973511.png',
    favicon: 'http://meetyou-api.oss-cn-hangzhou.aliyuncs.com/advertising/2022-10/13/logo-top2166565975152.png'
  }
}
const mutations = {
  SET_INFO: (state, data) => {
    state.info = data
  }
}

const actions = {
  setOpeInfo({ commit }, ope) {
    return new Promise((resolve, reject) => {

      resolve()
    })
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

